<template>
  <mc-table
    class="saved-filters__table"
    fit="small"
    headerhidden
    sortdisabled
    :data.prop="savedFilters"
    :columns.prop="[
      {
        id: 'name'
      },
      {
        id: 'criteria'
      },
      {
        id: 'delete'
      }
    ]"
    data-test="saved-filters-table"
  >
    <template v-for="item in savedFilters" :key="item.id">
      <div :slot="`${item.id}_name`">
        <mc-button
          appearance="neutral"
          variant="plain"
          :label="toTitleCase(item.filterName)"
          @click="applyFilter(item)"
        />
      </div>
      <div :slot="`${item.id}_criteria`">
        <div v-for="(key, index) in Object.keys(item)" :key="index" class="ml-2 d-inline">
          <span v-if="key != 'filterName'">
            <span class="mds-text--medium-bold"> {{ toTitleCase(key) }}: </span>
            <span class="ml-1"> {{ item[key].label }}</span>
          </span>
        </div>
      </div>
      <div :slot="`${item.id}_delete`">
        <mc-button
          appearance="neutral"
          variant="plain"
          :label="$t('common.delete')"
          data-test="delete-filter-button-save"
          @click="showConfirmationModal(item.id, item.filterName)"
        />
      </div>
    </template>
  </mc-table>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { filters } from "@/store/filters";
import { toTitleCase } from "@/lib/filters";
import emitter from "tiny-emitter/instance";
import { getExportImportPage } from "@/lib/utilities";

export default {
  name: "SavedFiltersTable",
  computed: {
    ...mapState(filters, ["savedFilters"])
  },
  methods: {
    ...mapActions(filters, ["updateVessel", "updateFromLocation", "updateToLocation", "updateRole"]),
    toTitleCase,
    showConfirmationModal(index, filterName) {
      this.deleteFilterIndex = index;
      this.deleteFilterName = filterName;
      emitter.emit("delete-filter-modal");
    },
    applyFilter(filter) {
      this.updateFromLocation(filter.from);
      this.updateToLocation(filter.to);
      this.updateVessel(filter.vessel);
      this.updateRole(filter.role);
      this.showModal = false;
      emitter.emit("toggle-saved-filters");
      this.$sendGAEvent({
        event: "DQCS",
        action: "Click",
        category: "Component",
        label: { data: `${getExportImportPage()} Shipment filter apply` }
      });
    }
  }
};
</script>
